import { subscriptionService } from '../../services';
import { checkIfSignedInAndOnline } from '../utils';

export async function subscriptionJobHandler() {
    const shouldRun = checkIfSignedInAndOnline();

    if (!shouldRun) {
        return;
    }

    await subscriptionService.fetchAndUpdate();
}
